import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserCompanyAccess, getUserTokeData, removeUser, addUser } from "../utils/userSlice";
import useRequireAuth from "../utils/useRequireAuth";
import { addParticularCompany } from "../utils/userSlice";
import { useLazyFetchCompanyPermissionsQuery } from "../utils/customer/customerTable";
import { addUserCompanyAccess } from "../utils/userSlice";

import useClickOutside from "../hooks/Screen/useClickOutside";
import Notification from "./userProfile/Notification";
import { getHexWithOpacity, getInitials } from "../utils/utilityFunctions/stringUtility";

import { ReactComponent as Notifications } from "../assets/images/icons/NotificationsIcon.svg";
import { useSidebar } from "../components/SidebarContext";
import TopTitle from "./GlobalFeature/TopTitle";
import { ReactComponent as ProfileIcon } from "../assets/images/icons/ProfileIcon.svg";
import { ReactComponent as PrivacyIcon } from "../assets/images/icons/PrivacyIcon.svg";
import { ReactComponent as SwitchCompanyIcon } from "../assets/images/icons/SwitchCompanyIcon.svg";
import { ReactComponent as SettingIcon } from "../assets/images/icons/SettingIcon.svg";
import { ReactComponent as LogoutIcon } from "../assets/images/icons/LogoutIcon.svg";
import ConfirmationDialog from "./UniversalComponents/ConfirmationDialogMulti";
import { useFetchCompanyListQuery } from "../utils/company/companySelector";
import AvatarName from "./UniversalComponents/AvatarName";
import {
  checkAccessPermission,
  getRefreshToken,
  getUserThemeColor,
  getUserToken,
  getCompanyId,
  getUserId,
  getOrganizations,
} from "../utils/utilityFunctions/localServices";
import { useSocket } from "./UniversalComponents/SocketContext";
import { Dialog } from "@mui/material";
import NotificationPopup from "./userProfile/NotificationPopup";
import {
  useMarkAllNotificationAsReadMutation,
  useMarkSingleNotificationAsReadMutation,
} from "./userProfile/GetAllNotification";
import { ReactComponent as OrgIcon } from "../assets/images/OrgIcon.svg";
import { LOGOUT_URL, USER_PREFERENCE } from "../utils/constants";
import { ReactComponent as AppIcon } from "../assets/images/icons/AppIcon.svg";
import { ReactComponent as CRMIcon } from "../assets/images/icons/CRM.svg";
import { ReactComponent as AccountingIcon } from "../assets/images/icons/Accounting.svg";
import { ReactComponent as AIIcon } from "../assets/images/icons/AI.svg";

function formatValue(item) {
  if (item) {
    const words = item.split(" ");
    const firstWord = words[0];
    const lastWord = words[words?.length - 1];
    const firstChar = firstWord.charAt(0).toUpperCase();
    const lastChar = lastWord.charAt(0).toUpperCase();
    return `${firstChar}${lastChar}`;
  }
  return null;
}

/** ————————————————————————————————————————————————
 * Browser-session wide “seen notifications” utilities
 *  - Shared across all tabs/windows via localStorage
 *  - Live-sync via BroadcastChannel (fallback to storage events)
 *  - Reset when last tab/window is closed
 * ———————————————————————————————————————————————— */
const SEEN_KEY = "notif.seen.v1";
const OPEN_TABS_KEY = "notif.openTabs.v1";
const CHANNEL_NAME = "notif.channel.v1";

function loadSeenIdsLS() {
  try {
    const raw = localStorage.getItem(SEEN_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? new Set(arr) : new Set();
  } catch {
    return new Set();
  }
}
function persistSeenIdsLS(setRef) {
  try {
    localStorage.setItem(SEEN_KEY, JSON.stringify([...setRef.current]));
  } catch {}
}
function parseOpenTabs() {
  try {
    const raw = localStorage.getItem(OPEN_TABS_KEY);
    const obj = raw ? JSON.parse(raw) : {};
    return typeof obj === "object" && obj ? obj : {};
  } catch {
    return {};
  }
}
function writeOpenTabs(obj) {
  try {
    localStorage.setItem(OPEN_TABS_KEY, JSON.stringify(obj));
  } catch {}
}
function mergeUniqueById(prev, next) {
  const map = new Map(prev.map((n) => [n.id, n]));
  for (const n of next) if (n && n.id) map.set(n.id, n);
  return [...map.values()];
}

/**
 * Simplified hooks usage (no unnecessary useMemo/useCallback) and config-driven UI.
 * - All menus/panels are rendered from plain config arrays.
 * - Kept your Tailwind classes and custom components.
 */

function twoInitials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join("");
}

const Header = () => {
  const user = useRequireAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useRequireAuth();
  const storedData = localStorage.getItem("company_data");
  const myUserData = localStorage.getItem("myUserData");
  const usetoken = myUserData ? JSON.parse(myUserData) : null;
  const tokens = token ? token : usetoken.token;
  const companyId = storedData ? JSON.parse(storedData) : null;
  console.log("companyId in abhishek", companyId);

  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isNotifOpen, setIsNotifOpen] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isAppOpen, setIsAppOpen] = useState(false);
  const [isCompanySwitch, setIsCompanySwitch] = useState(false);
  const [organizationsCount, setOrganizationsCount] = useState(0);

  const [markOne, { isLoading: singleBusy }] = useMarkSingleNotificationAsReadMutation();
  const [markAll, { isLoading: allBusy }] = useMarkAllNotificationAsReadMutation();
  const { data: companyCommnData, error, isLoading, refetch } = useFetchCompanyListQuery(tokens);

  const [messages, setMessages] = useState([]);
  const { socket, isConnected: isSocketConnected } = useSocket();
  const [taskPopup, setTaskPopup] = useState(false);
  const [activeApp, setActiveApp] = useState("CRM");

  // Session-wide seen IDs (shared across tabs/windows)
  const seenIdsRef = useRef(loadSeenIdsLS());
  const tabIdRef = useRef(crypto.randomUUID ? crypto.randomUUID() : String(Date.now() + Math.random()));
  const bcRef = useRef(null);
  const dropdownRef = useRef(null);

  const userData = useSelector((store) => store?.user);
  const sidebarContext = useSidebar();
  const headerProps = sidebarContext?.headerProps;
  const location = useLocation();

  const settingsRef = useClickOutside(() => setIsSettingsOpen(false));
  const profileRef = useClickOutside(() => setIsProfileOpen(false));

  const AppMenu = [
    { icon: <CRMIcon />, title: "CRM", url: "https://crm.expud.com/" },
    { icon: <AccountingIcon />, title: "Accounting", url: "http://accounting.expud.com/" },
    // { icon: <AIIcon />, title: "AI", url: "https://stage.unizooks.com" },
  ];

  //company permission api
  const [fetchCompanyPermissions, { data: companyPermissionsData, isSuccess: companyPermissionsSuccess }] =
    useLazyFetchCompanyPermissionsQuery();

  const updateAndNagivate = async () => {
    dispatch(addUserCompanyAccess(companyPermissionsData?.data));
    localStorage.setItem("company_preference", JSON.stringify(companyPermissionsData?.data?.preferences));
    localStorage.setItem("userPreferences", JSON.stringify(companyPermissionsData?.data?.user_preferences));
    applyThemeColors(companyPermissionsData?.data?.user_preferences?.theme_color);
    navigate("/customers");
  };

  const processUserData = (company) => {
    console.log("companyprocess", company);

    dispatch(
      addParticularCompany({
        company_id: company?.id,
        company_name: company?.company_name,
        company_logo: company?.company_logo,
        menuName: "",
      })
    );

    localStorage.removeItem("saved_view");

    // if (data?.workspaces && data?.workspaces.length > 1) {
    //   navigate("/organisations", { state: { workspaces: data?.workspaces } });
    // } else {
    fetchCompanyPermissions({ token: getUserToken(), companyId: company?.id });
    // }
  };

  useEffect(() => {
    if (companyPermissionsData && companyPermissionsData?.data) updateAndNagivate();
  }, [companyPermissionsData, companyPermissionsSuccess]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsAppOpen(false);
      }
    };

    if (isAppOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isAppOpen]);

  useEffect(() => {
    dispatch(getUserTokeData());
    dispatch(getUserCompanyAccess());
  }, [location, dispatch]);

  // Register / track open tabs, set up BroadcastChannel + storage sync, and clear seen on last tab close
  useEffect(() => {
    // Register this tab/window
    const tabs = parseOpenTabs();
    tabs[tabIdRef.current] = Date.now();
    writeOpenTabs(tabs);

    // BroadcastChannel for instant inter-tab sync (best effort)
    try {
      bcRef.current = new BroadcastChannel(CHANNEL_NAME);
    } catch {
      bcRef.current = null;
    }

    const onBCMessage = (ev) => {
      if (ev?.data?.type === "SEEN_UPDATE" && Array.isArray(ev.data.ids)) {
        for (const id of ev.data.ids) seenIdsRef.current.add(id);
        persistSeenIdsLS(seenIdsRef);
      }
    };
    bcRef.current && bcRef.current.addEventListener("message", onBCMessage);

    // Fallback: storage events when SEEN_KEY changes
    const onStorage = (e) => {
      if (e.key === SEEN_KEY && e.newValue) {
        try {
          const arr = JSON.parse(e.newValue || "[]");
          if (Array.isArray(arr)) {
            seenIdsRef.current = new Set(arr);
          }
        } catch {}
      }
    };
    window.addEventListener("storage", onStorage);

    // On unload: remove this tab; if it’s the last, clear SEEN_KEY
    const handleICompanySwitch = (companyId, company_name, company_logo) => {
      dispatch(
        addParticularCompany({
          company_id: companyId,
          company_name,
          company_logo,
        })
      );
      navigate(`/edit_company/${companyId}`);
    };

    const onUnload = () => {
      const current = parseOpenTabs();
      delete current[tabIdRef.current];
      writeOpenTabs(current);
      setTimeout(() => {
        const after = parseOpenTabs();
        if (Object.keys(after).length === 0) {
          try {
            localStorage.removeItem(SEEN_KEY);
          } catch {}
        }
      }, 300);
    };
    window.addEventListener("beforeunload", onUnload);

    return () => {
      window.removeEventListener("beforeunload", onUnload);
      window.removeEventListener("storage", onStorage);
      if (bcRef.current) {
        bcRef.current.removeEventListener("message", onBCMessage);
        bcRef.current.close();
        bcRef.current = null;
      }
      // Best-effort deregistration if unmount occurs without unload
      const left = parseOpenTabs();
      delete left[tabIdRef.current];
      writeOpenTabs(left);
    };
  }, []);

  // Socket: append only truly-new notifications (not seen in this browser session)
  useEffect(() => {
    if (!socket) return;

    const onConnect = () => {
      console.log("✅ Connected via WebSocket");
    };

    const onNotification = (payload) => {
      // Normalize payload to an array of notifications
      const arr = Array.isArray(payload?.data)
        ? payload.data
        : (payload?.data ? [payload.data] : [payload]).filter(Boolean);

      if (!arr.length) return;

      // Filter ONLY new IDs for this whole browser session
      const onlyNew = arr.filter((n) => n?.id && !seenIdsRef.current.has(n.id));
      if (onlyNew.length === 0) return;

      // Add to session-wide seen set
      for (const n of onlyNew) seenIdsRef.current.add(n.id);
      persistSeenIdsLS(seenIdsRef);

      // Broadcast to other tabs/windows immediately
      try {
        bcRef.current?.postMessage({ type: "SEEN_UPDATE", ids: onlyNew.map((n) => n.id) });
      } catch {}

      // Merge into UI and open popup (only once per new batch)
      setMessages((prev) => mergeUniqueById(prev, onlyNew));
      setTaskPopup(true);
    };

    const onDisconnect = () => {
      console.log("❌ Disconnected");
      // Keep seenIdsRef as-is; session persists until last tab closes
      setMessages((prev) => prev); // no-op; keep your current list
    };

    socket.on("connect", onConnect);
    socket.on("notification", onNotification);
    socket.on("disconnect", onDisconnect);

    return () => {
      socket.off("connect", onConnect);
      socket.off("notification", onNotification);
      socket.off("disconnect", onDisconnect);
    };
  }, [socket]);

  const handleCloseTaskPopup = () => {
    setTaskPopup(false);
    // Keep messages list if you want to show them elsewhere
    // setMessages([]); // optional if you prefer clearing the in-memory list
  };

  function toggleSettings() {
    setIsNotifOpen(false);
    setIsProfileOpen(false);
    setIsSettingsOpen((v) => !v);
  }

  function toggleNotifications() {
    setIsSettingsOpen(false);
    setIsProfileOpen(false);
    setIsNotifOpen((v) => !v);
  }
  function toggleProfile() {
    setIsNotifOpen(false);
    setIsSettingsOpen(false);
    setIsProfileOpen((v) => !v);
  }
  function goCompanyDelegation() {
    navigate("/company-and-permission");
  }

  function confirmLogout1() {
    // try {
    dispatch(removeUser());
    localStorage.clear();
    // navigate("/");
    // window.location.reload();
    window.location.href = `/?_=${Date.now()}`;

    // } catch (err) {
    //   console.error("Logout failed:", err?.message || err);
    // }
  }

  async function confirmLogout() {
    try {
      // Dont deleted commented below (below code is for server side validation)

      const response = await fetch(LOGOUT_URL, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
        },
      });

      window.location.replace(`/?_=${Date.now()}&cs=t`);

      if (!response.ok) {
        throw new Error("Logout failed");
      }
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  }
  // Replace the handleSwitchCompanyClick function with this fixed version:

  const handleSwitchCompanyClick = () => {
    // Check if we have exactly 2 companies
    if (companyCommnData?.data?.length === 2) {
      // Find the OTHER company (not the current one)
      const otherCompany = companyCommnData?.data?.find((list) => list.id !== companyId.company_id);

      console.log("othercompany", otherCompany);

      // Switch to the other company directly
      if (otherCompany) {
        processUserData(otherCompany);
      }
    } else {
      // If not exactly 2 companies, open the dialog
      setIsCompanySwitch(true);
    }
  };

  // const handleSwitchCompanyClick = () => {
  //   if (companyCommnData?.data?.length == 2) {
  //     const otherCompany = companyCommnData?.data?.find((list) => list.company_id !== companyId.company_id)[0];

  //     console.log("othercompany", otherCompany);

  //     processUserData(otherCompany);
  //   } else {
  //     setIsCompanySwitch(true);
  //   }
  // };

  useEffect(() => {
    const workspaces = getOrganizations();
    setOrganizationsCount(workspaces?.length || 0);
  }, [location]);
  const SETTINGS_SECTIONS = [
    {
      title: "Settings",
      items: [
        { label: "Company Settings" },
        { label: "Chart Of Accounts" },
        { label: "Payroll Settings" },
        { label: "Workers Comp" },
        { label: "HR Advisor" },
        { label: "Employee Benefits" },
        { label: "Get the desktop App" },
        { label: "Additional Info" },
        { label: "Priority Circle" },
      ],
    },
    {
      title: "Lists",
      items: [
        { label: "All List" },
        { label: "Products & Services" },
        { label: "Recurring Transactions" },
        { label: "Attachment" },
        { label: "Custom Field" },
        { label: "Tags" },
        { label: "Rules" },
      ],
    },
    {
      title: "Tools",
      items: [
        { label: "Manage Workflow" },
        { label: "Order Checks" },
        { label: "Import Data" },
        { label: "Import Desktop Data" },
        { label: "Reconcile" },
        { label: "Budgeting" },
        { label: "Spreadsheet Sync" },
        { label: "Audit Log", onClick: () => navigate("/audit-log") },
        { label: "Smart Look" },
        { label: "Resolution Center" },
      ],
    },
    {
      title: "Your Company",
      items: [
        { label: "Subscription & Billing" },
        { label: "Getting Started" },
        { label: "Sample Company" },
        { label: "Feedback" },
        {
          label: "Company Delegation",
          requiresPermission: "Add & Manage Groups & Permission",
          onClick: goCompanyDelegation,
          className: "text-778FA5 hover:text-black cursor-pointer",
        },
      ],
    },
  ];

  const PROFILE_MENU = [
    { label: "My Account", Icon: ProfileIcon },
    // { label: "Organisations", Icon: OrgIcon, onClick: () => navigate("/organisations") },
    ...(organizationsCount >= 2
      ? [
          {
            label: "Organisations",
            Icon: OrgIcon,
            onClick: () => navigate("/organisations"),
          },
        ]
      : []),
    // { label: "Switch Company", Icon: SwitchCompanyIcon, onClick: () => handleSwitchCompanyClick() },
    ...(companyCommnData?.data?.length >= 2
      ? [
          {
            label: "Switch Company",
            Icon: SwitchCompanyIcon,
            onClick: handleSwitchCompanyClick,
          },
        ]
      : []),
    { label: "Privacy", Icon: PrivacyIcon },
    { label: "Setting", Icon: SettingIcon, onClick: toggleSettings },
    { label: "Logout", Icon: LogoutIcon, onClick: () => setShowConfirmation(true) },
  ];

  const chipInitials = twoInitials(user?.name);
  const fullInitials = getInitials(user?.name || "");
  const unreadMessageCount = useMemo(() => messages.filter((n) => !n.is_read).length, [messages]);

  console.log("Header re-rendered", headerProps);

  return (
    <nav className="w-full bg-white z-[1200] sticky top-0 border-gray-300">
      <div className="px-3  lg:px-5 bg-white border-b h-16 flex items-center">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center justify-start rtl:justify-end">
            {Boolean(headerProps) && <TopTitle headerProps={headerProps} />}
          </div>

          <div className="flex items-center ms-3">
            {/* Action Tab  */}
            {Boolean(headerProps) && headerProps?.ActionTab && <div className="me-4">{headerProps.ActionTab()}</div>}

            {/* Presence + Notifications */}
            <div className="flex items-center gap-0.5">
              {/* <span className="px-2 text-sm">
                {isSocketConnected ? (
                  <span>
                    <span className="blink">🟢 </span>Online
                  </span>
                ) : (
                  <span>🔴 Offline</span>
                )}
              </span> */}

              <button
                id="dropdownNotificationButton"
                type="button"
                aria-haspopup="menu"
                aria-expanded={isNotifOpen}
                className="relative inline-flex items-center text-sm font-medium text-center  p-2 hover:bg-gray-100  group rounded-md"
                onClick={toggleNotifications}
              >
                <span className="text-primary">
                  <Notifications notifications={isNotifOpen} className="group-hover:fill-current fill-[#868D96]" />
                </span>
                {unreadMessageCount > 0 && (
                  <span className="absolute block text-primary min-w-[1.5rem] h-[1.5rem] px-1 bg-red-500 border-2 border-white text-white rounded-full -top-2 start-1.5">
                    {unreadMessageCount}
                  </span>
                )}
              </button>

              {isNotifOpen && (
                <div className="absolute top-[11px] right-1">
                  <Notification open={isNotifOpen} onClose={() => setIsNotifOpen(false)} />
                </div>
              )}

              <div ref={dropdownRef} className="relative " onClick={() => setIsAppOpen(!isAppOpen)}>
                <button className="text-primary p-2 hover:bg-gray-100 rounded-md group cursor-pointer">
                  <AppIcon
                    className={`group-hover:fill-current   ${isAppOpen === true ? "fill-current" : "fill-[#868D96]"}`}
                  />
                </button>

                {isAppOpen && (
                  <div className="absolute top-14 left-0 bg-white shadow-[0_0_4px_0_rgb(0,0,0,0.15)] rounded-lg p-4 w-64">
                    {AppMenu.map((item, index) => (
                      <a
                        key={index}
                        href={item.title === "CRM" ? null : `${item.url}?swc=${getRefreshToken()}`}
                        target="_self"
                        rel="noopener noreferrer"
                        onClick={() => setActiveApp(item.title)}
                      >
                        <div
                          className={`flex items-center justify-between p-3 rounded-xl cursor-pointer hover:bg-primary-hover transition mb-1 
                          ${activeApp === item.title ? "bg-primary-active" : ""}`}
                        >
                          <div className="flex items-center gap-3">
                            <span>{item.icon}</span>
                            <span className="text-primary-text font-medium text-[13px]">{item.title}</span>
                          </div>

                          {activeApp === item.title && (
                            <span className="text-[#00B386] text-[11px] font-medium">Active</span>
                          )}
                        </div>
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Profile */}
            <div className="px-3 ml-2 border-l-2 border-[#53525266]" ref={profileRef}>
              <button
                id="dropdownAvatarNameButton"
                type="button"
                aria-haspopup="menu"
                aria-expanded={isProfileOpen}
                className="capitalize flex items-center text-base pe-1 font-medium text-primary-text hover:text-primary md:me-0"
                onClick={toggleProfile}
              >
                <span className="sr-only">Open user menu</span>
                <span className="flex items-center flex-row gap-2">
                  <AvatarName
                    name={chipInitials}
                    size="medium"
                    bgColor={"#e8ecf299"}
                    textColor={"#7C7C83"}
                    borderColor={"#ABABAC"}
                  />
                  <span className="authname">{user?.name}</span>
                </span>
                <svg className="w-2.5 h-2.5 ms-3" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1 1L5 5L9 1"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              {isProfileOpen && <ProfileMenu name={user?.name} initials={fullInitials} items={PROFILE_MENU} />}
            </div>

            {/* Settings Mega-Panel */}
            {isSettingsOpen && (
              <div
                className="top-14 absolute bg-white border right-4 p-5 shadow-3 rounded-lg h-[446px] w-[900px]"
                ref={settingsRef}
              >
                <SettingsPanel sections={SETTINGS_SECTIONS} />
              </div>
            )}
          </div>
        </div>
      </div>

      {showConfirmation && (
        <ConfirmationDialog
          open={showConfirmation}
          onConfirm={confirmLogout}
          onClose={() => setShowConfirmation(false)}
          title="Logout Account?"
          message={`Are you sure want to logout from this account ?`}
          confirmVariant="delete"
          iconVariant="logout"
          confirmText="Yes"
          cancelText="No"
        />
      )}

      {isCompanySwitch && (
        <Dialog open={isCompanySwitch} onClose={() => setIsCompanySwitch(false)} maxWidth={"md"}>
          <div className="bg-white w-[500px] h-[500px] rounded-md flex flex-col items-center justify-center p-4">
            <div className="w-full flex items-center justify-between pb-4 px-1">
              <h3 className="font-Inter text-[20px] text-[#131313CC] font-semibold">Switch Company</h3>

              {/* Close Button */}
              <button onClick={() => setIsCompanySwitch(false)} className="text-gray-500 hover:text-gray-800 text-xl">
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            {/* ⬇⬇ YOUR SAME UL CODE MOVED HERE ⬇⬇ */}
            <div className="relative overflow-y-auto  w-full h-[500px] thinscrollbar rounded-md bg-white pr-2">
              <ul className="w-full flex flex-col gap-y-4">
                {!companyCommnData?.data
                  ? null
                  : companyCommnData?.data?.map((list) => (
                      <li
                        key={list.id}
                        className={`
                       group cursor-pointer rounded-lg px-4 py-5 flex items-center justify-between transition 
                      ${
                        list.company_name === companyId.company_name
                          ? "bg-primary-active" // active company background
                          : "bg-primary-lightest hover:bg-primary-hover shadow hover:shadow-card" // hover background for inactive
                      }
                    `}
                        // onClick={() => {
                        //   setIsCompanySwitch(list.id, list.company_name, list?.company_logo);
                        //   window.location.reload(true);
                        // }}
                      >
                        {/* LEFT SIDE */}
                        <div className="flex items-start gap-4 ">
                          {/* ROUND INITIAL CIRCLE */}
                          <div className="h-10 w-10 rounded-full bg-[#F5FAFF] border border-[#004EFF2B] flex items-center justify-center text-base font-semibold text-primary font-Inter px-2 py-2 ">
                            {list.company_name?.charAt(0)?.toUpperCase()}
                          </div>

                          {/* COMPANY NAME + LAST LOGIN */}
                          <div className="flex flex-col">
                            <span className="text-sm font-medium text-[#333]">{list.company_name}</span>
                            <span className="text-xs text-[#6F6F6F]">Last login on: 22 August 2025, 12:05 PM</span>
                          </div>
                        </div>

                        {/* RIGHT SIDE BUTTON */}
                        {/* <div>
                        {list.company_name === companyId.company_name ? (
                          // ACTIVE BUTTON (primary filled)
                          <button className="bg-primary text-white text-sm px-5 py-1.5 rounded-md">Active</button>
                        ) : (
                          // SWITCH BUTTON (primary border)
                          <button
                            className="border border-primary text-primary text-sm px-5 py-1.5 rounded-md group-hover:bg-primary-active/20"
      
                          >
                            Switch
                          </button>
                        )}
                      </div> */}
                        <div>
                          {list.company_name === companyId.company_name ? (
                            // ACTIVE BUTTON
                            <button className="bg-primary text-white text-sm px-5 py-1.5 rounded-md">Active</button>
                          ) : (
                            // SWITCH BUTTON
                            <button
                              onClick={() => processUserData(list)} // <-- CALL FUNCTION HERE
                              className="border border-primary text-primary text-sm px-5 py-1.5 rounded-md group-hover:bg-primary-active/20"
                            >
                              Switch
                            </button>
                          )}
                        </div>
                      </li>
                    ))}
              </ul>
            </div>
          </div>
        </Dialog>
      )}

      {taskPopup && (
        <NotificationPopup
          onMarkRead={async (id) => {
            await markOne({ payload: { notificationId: id } });
          }}
          onMarkAll={async () => {
            await markAll({});
          }}
          notifications={messages}
          busyIds={singleBusy ? [] : []}
          busyAll={allBusy}
          open={taskPopup}
          onClose={handleCloseTaskPopup}
        />
      )}
    </nav>
  );
};

/** ————————————————————————————————————————————————
 * Subcomponents (config-driven, unchanged in behavior)
 * ———————————————————————————————————————————————— */
const SettingsPanel = ({ sections }) => {
  return (
    <div className="flex justify-around">
      {sections.map((section) => (
        <div key={section.title} className="group">
          <h3 className={`mb-5 text-16 font-500 ${section.title === "Your Company" ? "text-203C50" : "text-gray-300"}`}>
            {section.title}
          </h3>
          <ul className="space-y-4 text-14 font-400 capitalize text-gray-300">
            {section.items.map((item) => {
              if (item.requiresPermission && !checkAccessPermission(item.requiresPermission)) return null;
              const className = item.className || "";
              return (
                <li
                  key={item.label}
                  className={`hover:text-black ${item.onClick ? "cursor-pointer text-778FA5" : ""} ${className}`}
                  onClick={item.onClick}
                >
                  {item.label}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
};

export const applyThemeColors = (color) => {
  if (!color) return;
  document.documentElement.style.setProperty("--color-primary", color);
  document.documentElement.style.setProperty("--color-primary-lightest", getHexWithOpacity(color, 2));
  document.documentElement.style.setProperty("--color-primary-hover", getHexWithOpacity(color, 5));
  document.documentElement.style.setProperty("--color-primary-active", getHexWithOpacity(color, 10));
  document.documentElement.style.setProperty("--color-primary-15", getHexWithOpacity(color, 15));
  document.documentElement.style.setProperty("--color-primary-20", getHexWithOpacity(color, 20));
  document.documentElement.style.setProperty("--color-primary-30", getHexWithOpacity(color, 30));
  document.documentElement.style.setProperty("--color-primary-40", getHexWithOpacity(color, 40));
  document.documentElement.style.setProperty("--color-primary-50", getHexWithOpacity(color, 50));
  document.documentElement.style.setProperty("--color-primary-60", getHexWithOpacity(color, 60));
  document.documentElement.style.setProperty("--color-primary-70", getHexWithOpacity(color, 70));
  document.documentElement.style.setProperty("--color-primary-80", getHexWithOpacity(color, 80));
  document.documentElement.style.setProperty("--color-primary-90", getHexWithOpacity(color, 90));
  document.documentElement.style.setProperty("--color-primary-text", "#131313cc");
  document.documentElement.style.setProperty("--color-primary-text-muted", "#C7C7C7");
  document.documentElement.style.setProperty("--color-secondary", "#ffffff");
};

const ProfileMenu = ({ name, initials, items }) => {
  const themeColors = ["#004EFF", "#008000", "#B22222", "#9370DB", "#574230", "#E45A92"];
  const [selectedColor, setSelectedColor] = useState("#004EFF");

  const handleSelectColor = async (color) => {
    setSelectedColor(color);
    try {
      fetch(USER_PREFERENCE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getUserToken()}`,
        },
        body: JSON.stringify({ theme_meta: { theme_color: color } }),
      });
    } catch (error) {
      console.error("Error saving theme color:", error);
    }

    applyThemeColors(color);

    // save UserPreferences() in local storage
    const userPreferences = {
      theme_color: color,
    };
    localStorage.setItem("userPreferences", JSON.stringify(userPreferences));
  };

  useEffect(() => {
    const savedColor = getUserThemeColor();
    setSelectedColor(savedColor);
  }, []);

  return (
    <div className="bg-white absolute mt-5 border rounded-lg shadow w-60 right-6" role="menu" aria-label="Profile">
      <div className="p-3">
        <ul className="ml-0 space-y-2">
          {/* <li className="text-778FA5 p-2 bg-primary rounded font-medium text-14">
            <div className="flex">
              <div className="mr-5">
                <AvatarName name={initials} size="medium" bgColor={"white"} textColor={`${selectedColor}`} />
              </div>
              <div className="flex items-center">
                <p className="capitalize text-white text-14 font-500 cursor-default">{name}</p>
              </div>
            </div>
          </li> */}

          {items.map(({ label, Icon, onClick }) => (
            <MenuItem key={label} onClick={onClick}>
              <div style={{ "--icon-color": selectedColor }}>
                <Icon className="fill-[#969BA9] group-hover:fill-[var(--icon-color)]" />
              </div>
              {label}
            </MenuItem>
          ))}

          {/* <div className="mt-3">
            <p className="text-gray-500 text-sm mb-1 font-medium">Mode</p>
            <div className="flex bg-[#F3F4F6] rounded-full w-max p-1">
              <button className="px-3 py-1 bg-[#004EFF] text-white rounded-full text-sm flex items-center gap-1">
                ☀️ Day
              </button>
              <button className="px-3 py-1 text-gray-600 rounded-full text-sm flex items-center gap-1">🌙 Night</button>
            </div>
          </div> */}

          <div className="mt-3 border-t border-gray-300 mx-2" />
          {/*  Dynamic Color Circles */}
          <div className="flex gap-3 py-2 justify-center ">
            {themeColors.map((color) => (
              <div
                key={color}
                onClick={() => handleSelectColor(color)}
                className={`w-6 h-6 rounded-full cursor-pointer border-2 transition-all duration-150 ${
                  selectedColor === color
                    ? "ring-2 ring-offset-2 ring-[var(--color-primary-50)] border-[var(--color-primary-50)]"
                    : "border-gray-300"
                }`}
                style={{ backgroundColor: color }}
                title={color}
              ></div>
            ))}
          </div>
        </ul>
      </div>
    </div>
  );
};

const MenuItem = ({ children, onClick }) => (
  <li
    onClick={onClick}
    className="text-778FA5 flex cursor-pointer hover:text-primary group hover:bg-primary-hover items-center gap-5 p-2 bg-white rounded text-14 hover:border-l-2 hover:border-primary border-l-2 border-white"
    role="menuitem"
  >
    {children}
  </li>
);

export default Header;
